module.exports = __webpack_public_path__ + "img/introduce-3.7f591e53.png";